<template>
  <div>
    <page-title color="grape">Reporting</page-title>
    <async-loader v-if="reportsLoading"/>
    <template v-else>
      <report-type
        :report-type="reportType"
      />
    </template>
  </div>
</template>
<script>
  import ReportType from './shared/ReportType.vue'
  import reporting from '@mixins/reporting'
  import PageTitle from './shared/PageTitle'
  import fetchable from '@mixins/fetchable'

  export default {
    mixins: [fetchable, reporting],
    components: {
      PageTitle,
      ReportType
    },
    computed: {
      fetchers () {
        return [
          {
            action: 'reporting/GET_REPORTS',
            options: {
              params: {
                type: this.code
              }
            }
          }
        ]
      },
      code() {
        return this.$route.params.reportingCategory
      },
      reportType () {
        return this.reportTypes.find(report => {
          return report.code === this.code
        })
      }
    }
  }
</script>
